import constantService from '../../services/constantService'

export default {
  state: {
    constants: {},
    monthlyFee: [],
    monthlyFeeIllness: 0,
    medConsult: 0,
    percentageArray: [],
  },
  mutations: {
    SET_CONSTANTS(state, data) {
      state.constants = data
    },
    SET_MONTHLY_FEE(state, data) {
      state.monthlyFee = data
    },
    SET_MONTHLY_FEE_ILLNESS(state, data) {
      state.monthlyFeeIllness = data
    },
    SET_MED_CONSULT(state, data) {
      state.medConsult = data
    },
    SET_PERCENTAGE(state, data) {
      state.percentageArray = data
    },
  },
  actions: {
    getAllConstants({ commit }, payload) {
      constantService.getConstants().then(response => {
        commit('SET_CONSTANTS', response.data)
      })
      constantService.getMonthlyFee(payload.age).then(response => {
        commit('SET_MONTHLY_FEE', response.data)
      })
      constantService.getMonthlyFeeIllness(payload.age).then(response => {
        commit('SET_MONTHLY_FEE_ILLNESS', response.data.Monthly_fee_illness[0])
        commit('SET_MED_CONSULT', response.data.Medical[0])
      })
      constantService.getPercentage().then(response => {
        let percentageArray = response.data.map(item =>
          item.toString().replace('.', ',')
        )
        commit('SET_PERCENTAGE', percentageArray)
      })
    },
  },
  getters: {},
}
